import React from 'react'
import type { IImageDetailContext } from './interface'

export const ImageDetailContext:IImageDetailContext | any = React.createContext({})
